import React from 'react'

// material ui
import Container from '@mui/material/Container'

// components
import Loading from 'components/atoms/Loading'
import EditPersonHeader from 'components/shared/EditPersonHeader'
import Breadcrumbs from 'components/shared/Breadcrumbs'
import Form from 'components/account/EmergencyContacts/Form'

const EditEmergencyContact = props => {
  const {
    emergencyContact,
    account,
    season,
    queryLoading,
    mutationLoading,
    form
  } = props

  return (
    <Container maxWidth='md'>
      <Breadcrumbs
        crumbs={[
          ['Account Overview', '/'],
          ['Emergency Contacts'],
          [emergencyContact ? emergencyContact.firstName : '…']
        ]}
      />
      <EditPersonHeader
        personType='Emergency Contact'
        person={emergencyContact}
        season={season}
        account={account}
      />
      {queryLoading || (!form?.id && !!emergencyContact) ? (
        <Loading />
      ) : (
        <Form
          buttonText={mutationLoading ? 'Saving…' : 'Save'}
          editMode
          showFormFields={!!emergencyContact}
          {...props}
        />
      )}
    </Container>
  )
}

export default EditEmergencyContact
